import {React, useRef, useState} from 'react';
import {useAuth} from "../../hooks/useAuth";
import Layout from "../../components/Layout/Layout";
import classes from './Login.module.scss';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import user from '../../assets/user.svg';
import key from '../../assets/key.svg';
import AuthService from '../../services/auth-services'
import {useNavigate} from "react-router-dom";

const required = (value) => {
    if (!value) {
        return (
            <div className="invalid-feedback absolute left-1/2 -translate-x-1/2 -bottom-5 text-red-500 text-xs">
                Kérjük töltse ki a mezőt!
            </div>
        );
    }
};

const Login = () => {
    const form = useRef();
    const checkBtn = useRef();
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const {login} = useAuth();
    const {storeRole} = useAuth();
    const {storeConfirmed} = useAuth();
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage("");
        setLoading(true);
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            AuthService.loginUser(userName, password).then((res) => {
                console.log(res)
                login({
                    token: res.access_token
                });
                storeRole({
                    role: res.user.role
                })
                storeConfirmed({
                    confirmed: res.user.is_verified
                })
            }, (error) => {
                const resMessage = (error.response && error.response.data && error.response.data.message) || Object.values(error.response.data.error)[0] || error.message || error.toString();
                setLoading(false);
                setMessage(resMessage);
            });
        } else {
            setLoading(false);
        }
    };

    const onChangeUserName = e => {
        const value = e.target.value;
        setUserName(value)
    }

    const onChangePassword = e => {
        const value = e.target.value;
        setPassword(value)
    }

    return (<Layout>
        <div className={"flex w-full items-center justify-center " + classes["background"]}>
            <div className="bg-white px-8 py-10 rounded-md md:w-[540px] mx-8">
                <div className="text-center">
                    <h1 className="font-header font-black text-2xl text-black">GLOSTER VIDEO PORTAL</h1>
                    <p className={'pb-5 border-b-2 border-brandSecondary mt-2 mb-5 md:mb-12 text-xs text-black'}>Adminisztrátori
                        bejelentkezés</p>
                    <div className={'flex flex-col gap-8 mb-5 md:mb-8 items-center'}>
                        <Form onSubmit={handleSubmit} className="flex w-full flex-col gap-7 items-center" ref={form}>
                            <div className="flex relative w-full justify-center">
                                <label htmlFor="username"
                                       className='flex w-8 px-2 bg-bgGray rounded-l-md cursor-pointer'>
                                    <img src={user} alt="felhasználó icon"/>
                                </label>
                                <Input type="text" id="username" onChange={onChangeUserName} value={userName}
                                       className="login-input w-[350px]" required
                                       placeholder='Felhasználónév' validations={[required]}/>
                            </div>
                            <div className="flex">
                                <label htmlFor="password" className='flex w-8 px-2 bg-bgGray rounded-l-md'><img
                                    src={key} alt=""/></label>
                                <Input type="password" id="password" value={password} onChange={onChangePassword}
                                       className="login-input w-[350px]" required
                                       placeholder='Jelszó' valdations={[required]}/>
                            </div>

                            {message && (
                                <div className="form-group">
                                    <div className="alert alert-danger" role="alert">
                                        {message}
                                    </div>
                                </div>
                            )}
                            <button type="send" className='btn-primary w-fit flex gap-x-2 mt-4'>
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 512 512" className='w-4 h-4 fill-white'>
                                    <path
                                        d="M352 96h64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96-43 96-96V128c0-53-43-96-96-96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-7.5 177.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H160v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"/>
                                </svg>
                                bejelentkezés
                            </button>
                            <CheckButton style={{display: "none"}} ref={checkBtn}/>
                        </Form>
                    </div>
                    <p className={'text-[10px] md:text-xs'}>Elfelejtetted a jelszavadat?</p>
                    <p className={'text-[10px] md:text-xs'}>Kérj új jelszót az <a href="/elfelejtett-jelszo"
                                                                                  className='link-primary'>alábbi
                        linken</a>.</p>
                </div>

            </div>
        </div>
    </Layout>);
};

export default Login;
